export default "__VITE_ASSET__BIPC23NQ__"